import './style/App.css';
import '@arco-design/web-react/dist/css/arco.css';
import { BrowserRouter } from 'react-router-dom';
import Routers from "./routers";
import { ComponentConfig } from './config';
import { ConfigProvider } from '@arco-design/web-react';
import enUS from "@arco-design/web-react/es/locale/en-US";

function App() {
  return (
    <div className="App">
      <ConfigProvider componentConfig={ComponentConfig}
        locale={enUS}>
        <BrowserRouter>
          <Routers />
        </BrowserRouter>
      </ConfigProvider>
    </div>
  );
}

export default App;
